import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';

import { FetchDatasetParams, RelatedDataset } from './types';

const fetchRelatedDatasets = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/spold/related_datasets`, { params });

  return data;
};

const useRelatedDatasets = (isShowingV4: boolean, id?: string) => {
  const { ver: version, system_model } = useVersionInfo();
  return useQuery<RelatedDataset[], AxiosError>({
    queryKey: ['relatedDatasets', id, version, system_model],
    queryFn: () => fetchRelatedDatasets({ dataset_id: id as string, version, system_model }),
    enabled: !isShowingV4 && !!id,
    retry: false,
  });
};

export default useRelatedDatasets;
